import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CmpsIconRegistry } from '@cmps/ng-uikit';

import { CmpsLegendItemComponent } from './legend-item.component';

@NgModule({
    declarations: [CmpsLegendItemComponent],
    exports: [CmpsLegendItemComponent],
})
export class CmpsCoachingIcon {
    constructor(
        private readonly _domSanitizer: DomSanitizer,
        private readonly _iconRegistry: CmpsIconRegistry,
    ) {
        [
            [
                'solid-line',
                '<line x1="2" y1="12" x2="22" y2="12" style="stroke-width: 3px;"></line>',
            ],
            [
                'solid-line-thick',
                '<line x1="2" y1="12" x2="22" y2="12" style="stroke-width: 5px;"></line>',
            ],
            [
                'dashed-line',
                '<line style="stroke-width: 3px; stroke-dasharray: 3, 4, 6, 4;" x1="2" x2="22" y1="12" y2="12"></line>',
            ],
            ['circle', '<circle r="12" cx="12" cy="12"></circle>'],
            [
                'circle-path',
                `<circle r="2" cx="4" cy="12"></circle>
                <circle r="2" cx="12" cy="12"></circle>
                <circle r="2" cx="20" cy="12"></circle>`,
            ],
        ].forEach(([name, icon]) => {
            _iconRegistry.addSvgIconFromHtml(
                name,
                _domSanitizer.bypassSecurityTrustHtml(
                    `<svg id="${name}">${icon}</svg>`,
                ),
                'cmps-coaching',
            );
        });
    }
}
